import { PatientActions } from 'src/redux/actions/constant';

const {
  GET_ALL_PATIENT_PRIOR_CHARGES_SUCCESS,
  GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST,
  GET_ALL_PATIENT_PRIOR_CHARGES_FAILURE,
} = PatientActions;

const initialPatientPriorChargesState: object = {
  priorCharges: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getAllPatientPriorChargesReducer = (state = initialPatientPriorChargesState, action: any) => {
  switch (action.type) {
    case GET_ALL_PATIENT_PRIOR_CHARGES_SUCCESS: {
      return {
        ...state,
        isError: false,
        loading: false,
        priorCharges: action.payload?.data,
      };
    }

    case GET_ALL_PATIENT_PRIOR_CHARGES_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        priorCharges: null,
        loading: false,
      };

    case GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};

